// Decides what a detail page (/rooms/[slug], /flavors/[id],
// /events/meeting-halls/[slug]) should do with its useFetch result.
// Returns null when the record loaded, otherwise the createError() options
// the page must throw — so an unknown slug is a real 404 instead of a
// 200 page with a self-referencing canonical and an empty H1.
//
// The API currently answers an unknown slug with HTTP 500 and the Laravel
// message "Call to a member function translate() on null" (not a 404), so
// that exact case is mapped to 404 too. Any other failure (429 rate limit,
// network error, real 5xx) is a 503: the record may well exist, so it must
// be neither indexed as an empty page nor reported as gone.
export function detailPageError(data, error) {
  if (!error) {
    if (data && typeof data === 'object' && data.title) return null;
    return { statusCode: 404, statusMessage: 'Page Not Found', fatal: true };
  }

  const status = error.statusCode ?? error.status;
  const message = error.data?.message || '';
  if (status === 404 || (status === 500 && message.includes('on null'))) {
    return { statusCode: 404, statusMessage: 'Page Not Found', fatal: true };
  }
  return { statusCode: 503, statusMessage: 'Service Unavailable', fatal: true };
}
